/**************************************************
 * Nombre:       Seccion_Resultados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Lista_Productos from "./Componentes/Lista_Productos";
import Home_Categorias from "./Componentes/Home_Categorias";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {irArriba} from "../../Utilidades/irArriba";
import Titulo_Resultado from "./Componentes/Titulo_Resultado";
import {useParams} from "react-router";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {buscarPalabra} from "../../Modulo_Algolia/Funciones/buscarPalabra";
import Home_Suscripcion from "./Componentes/Home_Suscripcion";

const Seccion_Resultados = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [palabra, setPalabra] = useState("")
    const [productos, setProductos] = useState([])
    const [id, setId] = useState()


    useEffect(() => {


        if (parms && parms.tipo && parms.id && parms.id !== id) {
            setId(parms.id)
            irArriba()
            let tipo = parms.tipo
            let id = parms.id
            setPalabra(id)
            setProductos([])

            if (tipo === 'subCat') {

                let w = [where('tipo', '==', id), where('estado', '==', 'Publicado')]
                obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
                    if (dox.res) {
                        setProductos(dox.data)
                    }
                })
            }

            if (tipo === 'palabra') {

                buscarPalabra({palabra: id, coleccion: 'productos'}).then((dox) => {
                    console.log(dox)
                    setProductos(dox)
                })
            }


        }

    }, [parms])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Titulo_Resultado palabra={palabra}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? -4 : 0}}>
                <Lista_Productos productos={productos}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 8 : 16, mb: sCell ? 8 : 16}}>
                <Home_Categorias/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 12}}>
                <Home_Suscripcion/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Resultados